import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Dimmer, List } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import Select from 'react-select';
import PutObject from '../../lib/putObject';

const globeroles = [{ label: 'Shopper', value: 'Shopper' }, { label: 'Traveller', value: 'Traveller' }]

const MessageEditModal = ({ recordId, closeMainModal, reload }) => {
  const { data, loading, handleChange } = useFetch(`message/${recordId}`);
  const [saveLoading, toggleSaveLoading] = useState(false)
  const [selectedRoles, setSelectedRoles] = useState()

  useEffect(() => {
    if (!loading) {
      setSelectedRoles(data.targets.map(t => { return { label: t, value: t } }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const saveEdit = () => {
    const editedMessage = {
      _id: recordId,
      message: data.message,
      answers: data.answers,
      targets: selectedRoles.map(r => r.value)
    }

    toggleSaveLoading(true)
    PutObject('message', editedMessage).then(() => {
      toggleSaveLoading(false)
      if (typeof reload === 'function') {
        reload()
      }
      closeMainModal()
    });
  }

  return (
    <Card>
      <Dimmer active={loading} loader={loading}>
        <Card.Header>
          <Card.Title>Edit Message</Card.Title>
          <Card.Options>
            <Button size="sm" icon="x" onClick={() => closeMainModal()} />
          </Card.Options>
        </Card.Header>
        {!loading && data &&
          <Card.Body>
            <Form>
              <Form.Input
                name='message'
                label='Message'
                placeholder=''
                value={data['message']}
                onChange={handleChange}
              />

              <Form.Input
                name='answers.0'
                label='answers1'
                placeholder=''
                value={data.answers[0]}
                onChange={handleChange}
              />

              <Form.Input
                name='answers.1'
                label='answers2'
                placeholder=''
                value={data.answers[1]}
                onChange={handleChange}
              />

              <Form.Input
                name='answers.2'
                label='answers3'
                placeholder=''
                value={data.answers[2]}
                onChange={handleChange}
              />

              <Form.Label>Targets: </Form.Label>
              <List.GroupItem>
                <Select
                  value={selectedRoles}
                  options={globeroles}
                  isMulti
                  placeholder="Role"
                  onChange={setSelectedRoles}
                />
              </List.GroupItem>
            </Form>
          </Card.Body>
        }
        <Card.Footer>
          <div style={{ textAlign: 'right' }}>
            <Button
              color="primary"
              size="sm"
              className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
              onClick={saveEdit}
              disabled={saveLoading}
            >
              Edit
            </Button>
          </div>
        </Card.Footer>
      </Dimmer>
    </Card>
  )
}

export default MessageEditModal;